<template>
  <div class="accordion">
    <div class="card px-3">
      <button type="button" @click="expanded = !expanded">
        {{ title }}
        <i :class="{ 'rotate-up': expanded }" class="fas fa-chevron-down" />
      </button>
      <div :class="{ closed: !expanded }" class="collapse" :style="collapseStyles">
        <div ref="cardBody" class="card-body">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseAccordion',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
      collapseObserver: null,
      collapseStyles: {
        '--card-body-height': null,
      },
    };
  },
  mounted() {
    this.setupCollapseHeight();
  },
  beforeDestroy() {
    this.collapseObserver.disconnect();
  },
  methods: {
    setCollapseHeight() {
      const collapseHeightOffset = 300;

      this.collapseStyles['--card-body-height'] = `${
        this.$refs.cardBody.clientHeight + collapseHeightOffset
      }px`;
    },
    setupCollapseHeight() {
      this.setCollapseHeight();

      this.collapseObserver = new MutationObserver(() => this.setCollapseHeight());

      this.collapseObserver.observe(this.$refs.cardBody, { attributes: true, subtree: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.rotate-up {
  transform: rotate(180deg);
}

.collapse {
  display: block;
  max-height: var(--card-body-height);
  transition: max-height 500ms;

  &.closed {
    max-height: 0;
  }
}

.card {
  i.fas {
    transition: transform 350ms;
  }

  > button {
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #999;
  }
}
</style>
